import React from "react"
import { SimpleGrid, Container, Heading, Flex } from "@chakra-ui/react"
import { ContactAnimation } from "./animations/contact"
import { Form } from "../../"

export function Contact() {
  return (
    <section>
      <Container pt={{ base: 0, lg: 20 }}>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 0, lg: 8 }}
          alignItems="center"
        >
          <ContactAnimation
            maxH={{ base: "350px", lg: "600px" }}
            ml={{ base: "auto", lg: -12, xl: 0 }}
            mr={{ base: "auto", lg: 0 }}
            mb={{ base: 4, lg: 0 }}
          />
          <Flex id="contact" flexDirection="column">
            <Heading
              size="3xl"
              fontWeight="semibold"
              mb={2}
              textAlign={{ base: "center", lg: "left" }}
            >
              Send us a message
            </Heading>
            <Heading
              color="primary.200"
              fontSize="lg"
              fontWeight="medium"
              textAlign={{ base: "center", lg: "left" }}
              mb={8}
            >
              We look foward to hearing from you
            </Heading>

            <Form />
          </Flex>
        </SimpleGrid>
      </Container>
    </section>
  )
}
